import React, { useEffect, useState } from "react";
import { FaBell, FaMoneyBillWave, FaCalendarAlt, FaHome } from "react-icons/fa";
import MiniChart from "./MiniChart";
import "./DashboardHeader.css";

const DashboardHeader = ({
  totalChamadas,
  totalSolicitacoesConta,
  tendenciaChamadas,
  tendenciaContas,
  modoEscuro = false,
}) => {
  const [mounted, setMounted] = useState(false);
  const [dataInicioSemana, setDataInicioSemana] = useState("");
  const [dataFimSemana, setDataFimSemana] = useState("");
  const [animateCards, setAnimateCards] = useState(false);

  useEffect(() => {
    // 🗓️ Calcular intervalo da semana: Segunda a Domingo
    const hoje = new Date();
    const diaSemana = hoje.getDay(); // 0 = domingo, 1 = segunda, ..., 6 = sábado

    // Segunda-feira da semana atual
    const segunda = new Date(hoje);
    segunda.setDate(hoje.getDate() - (diaSemana === 0 ? 6 : diaSemana - 1));

    // Domingo da semana atual
    const domingo = new Date(segunda);
    domingo.setDate(segunda.getDate() + 6);

    const formatar = (data) =>
      data.toLocaleDateString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });

    setDataInicioSemana(formatar(segunda));
    setDataFimSemana(formatar(domingo));
    setMounted(true);

    // Trigger animation after mount
    setTimeout(() => setAnimateCards(true), 100);
  }, []);

  const tema = modoEscuro ? "dark-mode" : "light-mode";

  // Calcular totais para exibição adicional
  const totalGeral = totalChamadas + totalSolicitacoesConta;
  const percentualChamadas = totalGeral > 0 ? ((totalChamadas / totalGeral) * 100).toFixed(1) : 0;
  const percentualContas = totalGeral > 0 ? ((totalSolicitacoesConta / totalGeral) * 100).toFixed(1) : 0;

  return (
    <div className={`dashboard-header ${tema}`}>
      {/* Header Section */}
      <div className="header-top">
        <div className="header-title-section">
          <div className="header-icon">
            <FaHome size={32} />
          </div>
          <div className="header-text">
            <h2 className="header-title">Resumo Geral</h2>
            <p className="header-subtitle">Visão geral do desempenho da semana</p>
          </div>
        </div>

        <div className="header-date-section">
          <div className="date-badge">
            <FaCalendarAlt size={16} className="date-icon" />
            <span className="date-range">
              {dataInicioSemana} até {dataFimSemana}
            </span>
          </div>
        </div>
      </div>

      {/* Stats Cards Section */}
      <div className="stats-container">
        <div className={`stats-grid ${animateCards ? "animate" : ""}`}>
          {/* Card: Total de Chamadas */}
          <div className="stat-card stat-card-primary">
            <div className="stat-card-header">
              <div className="stat-icon stat-icon-primary">
                <FaBell size={24} />
              </div>
              <div className="stat-info">
                <h5 className="stat-label">Total de Chamadas</h5>
                <p className="stat-percentage">{percentualChamadas}% do total</p>
              </div>
            </div>

            <div className="stat-card-body">
              <div className="stat-value-section">
                <h2 className="stat-value">{totalChamadas}</h2>
                <span className="stat-unit">chamadas</span>
              </div>

              {mounted && (
                <div className="stat-chart-container">
                  <p className="chart-label">Tendência da semana</p>
                  <MiniChart dataPoints={tendenciaChamadas} color="#6366f1" />
                </div>
              )}
            </div>

            <div className="stat-card-footer">
              <span className="stat-trend">📈 Monitorando em tempo real</span>
            </div>
          </div>

          {/* Card: Solicitações de Conta */}
          <div className="stat-card stat-card-secondary">
            <div className="stat-card-header">
              <div className="stat-icon stat-icon-secondary">
                <FaMoneyBillWave size={24} />
              </div>
              <div className="stat-info">
                <h5 className="stat-label">Solicitações de Conta</h5>
                <p className="stat-percentage">{percentualContas}% do total</p>
              </div>
            </div>

            <div className="stat-card-body">
              <div className="stat-value-section">
                <h2 className="stat-value">{totalSolicitacoesConta}</h2>
                <span className="stat-unit">solicitações</span>
              </div>

              {mounted && (
                <div className="stat-chart-container">
                  <p className="chart-label">Tendência da semana</p>
                  <MiniChart dataPoints={tendenciaContas} color="#ec4899" />
                </div>
              )}
            </div>

            <div className="stat-card-footer">
              <span className="stat-trend">📈 Monitorando em tempo real</span>
            </div>
          </div>
        </div>

        {/* Summary Stats */}
        <div className="summary-stats">
          <div className="summary-stat-item">
            <span className="summary-label">Total Geral</span>
            <span className="summary-value">{totalGeral}</span>
          </div>
          <div className="summary-stat-item">
            <span className="summary-label">Média Diária</span>
            <span className="summary-value">{(totalGeral / 7).toFixed(1)}</span>
          </div>
          <div className="summary-stat-item">
            <span className="summary-label">Taxa de Chamadas</span>
            <span className="summary-value">{percentualChamadas}%</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardHeader;
